import { ErrorBoundary } from "react-error-boundary"
import { Flex, Text, Heading, Link } from "@chakra-ui/react"
import logger from "util/loggers/loggerBrowser"

export default function CrfErrorBoundary({ children }) {
    return (
        <ErrorBoundary FallbackComponent={ErrorFallback} onError={errorHandler}>
            {children}
        </ErrorBoundary>
    )
}

const errorHandler = error => {
    if (process.env.NODE_ENV === "development") return
    logger.error(error.message, { error })
}

function ErrorFallback() {
    return (
        <Flex direction="column" flexGrow={1} justify="center" align="center" bgColor="color5" color="#fff">
            <Heading as="h2" color="#fff" mt={0} lineHeight={1.1}>
                Oops... Something went wrong.
            </Heading>
            <Text maxW="100%">We&apos;re looking into it.</Text>
            <Text maxW="100%">
                Please return to the{" "}
                <Link href="/" textDecoration="underline">
                    homepage
                </Link>
                .
            </Text>
        </Flex>
    )
}
